export interface AdditionalDevelopmentInterface {
    id: number;
    userId: number;
    title: string;
    points?: number;
    dateAndTimeSubmitted: Date;
    dateAndTimeCompleted?: Date;
    submissionText?: string;  
}

export class AdditionalDevelopment implements AdditionalDevelopmentInterface {
    public id: number;
    public userId: number;
    public title: string;
    public points?: number;
    public dateAndTimeSubmitted: Date;
    public dateAndTimeCompleted?: Date;
    public submissionText?: string;  

    // Constructor to initialize properties
    constructor(
        id: number,
        userId: number,
        dateAndTimeSubmitted: Date,
        title: string,
        points?: number,
        dateAndTimeCompleted?: Date,
        submissionText?: string,
    ) {
        this.id = id;
        this.userId = userId;
        this.points = points;
        this.dateAndTimeSubmitted = dateAndTimeSubmitted;
        this.dateAndTimeCompleted = dateAndTimeCompleted;
        this.submissionText = submissionText;
        this.title = title;
    }

    static fromJson(json: any): AdditionalDevelopment {
        return new AdditionalDevelopment(
            json.id,
            json.userId,
            json.dateAndTimeSubmitted ? new Date(json.dateAndTimeSubmitted) : new Date(),
            json.title,
            json.points,
            json.dateAndTimeCompleted ? new Date(json.dateAndTimeCompleted) : undefined,
            json.submissionText
        );
    }

    static fromJsonArray(jsonArray: any[]): AdditionalDevelopment[] {
        return jsonArray.map(item => AdditionalDevelopment.fromJson(item));
    }
}
